import React from 'react';
import { Link } from 'react-router-dom';
import { OPERATOR } from './legalInfo';

const emailIsSet = !/^\[.*\]$/.test(OPERATOR.email);

// Each opens the person's email app with a subject filled in.
export const CONTACT_OPTIONS = [
  { label: 'General question', subject: 'Question about Frolik' },
  { label: 'Problem with an event', subject: 'Problem with an event', hint: 'Fastest: use the Report link on the event page.' },
  { label: 'Privacy or data request', subject: 'Privacy or data request' },
  { label: 'Partnerships & press', subject: 'Partnership or press enquiry' },
];

// Answers describe how Frolik works today; update them if features change.
export const FAQS = [
  {
    q: 'What is Frolik?',
    a: 'A place to find and share local events. Anyone can browse; with a free account you can create events, RSVP, chat and share collectible event cards.',
  },
  {
    q: 'Is Frolik free?',
    a: 'Yes. There are no fees, ads or paid features.',
  },
  {
    q: 'How do I create an event?',
    a: 'Sign in, tap the frog button at the top of the home page, fill in the title, place, date and time, pick a background and choose Public or Private. If you leave the place empty, Frolik can suggest your current city, and only uses it if you confirm.',
  },
  {
    q: 'Why isn’t my event on the home page yet?',
    a: 'Public events are reviewed before they’re listed, to keep scams and spam out. Until then your event shows “Waiting for review”. If it isn’t approved, you’ll see the reason on the event.',
  },
  {
    q: 'What’s the difference between public and private?',
    a: 'Public events are listed on the home page after review. Private events aren’t listed: only people you share the link with can see them.',
  },
  {
    q: 'How do I share my event?',
    a: 'Open the event and tap Share. You get a collectible card for Instagram stories or posts, plus Telegram, WhatsApp and a link to copy.',
  },
  {
    q: 'How do I get notified about new comments?',
    a: 'Tap “Notify me” in an event’s chat. On iPhone, first add Frolik to your Home Screen (Share → Add to Home Screen) and open it from there. Tap the button again to stop.',
  },
  {
    q: 'Does Frolik use cookies or track me?',
    a: 'No cookies, analytics or ads. Frolik only keeps what’s needed on your device, like staying signed in and your likes. See “Your data” in the footer.',
  },
  {
    q: 'How do I report an event?',
    a: 'Open the event and tap Report at the bottom. Reports are anonymous and reviewed by our team.',
  },
  {
    q: 'How do I download my data or delete my account?',
    a: 'Sign in and open “Your data” in the footer. Deleting your account also deletes the events you created.',
  },
  {
    q: 'I forgot my password. Can you reset it?',
    a: 'Accounts don’t have an email address, so we can’t send a reset link or prove who owns an account. Keep your password somewhere safe; if you’re stuck, contact us and we’ll see what we can do.',
  },
  {
    q: 'Who can use Frolik?',
    a: 'Anyone aged 16 or over who follows our Terms of Service.',
  },
];

export default function ContactPage() {
  return (
    <div className="contact-page">
      <div className="contact-card">
        <h1>Contact us</h1>
        <p className="contact-intro">
          Questions, problems or ideas? Pick a topic and your email app will open. We read every
          message and reply in English or German.
        </p>

        <div className="contact-buttons">
          {CONTACT_OPTIONS.map((option) =>
            emailIsSet ? (
              <a
                key={option.label}
                className="contact-button"
                href={`mailto:${OPERATOR.email}?subject=${encodeURIComponent(option.subject)}`}
              >
                <strong>{option.label}</strong>
                {option.hint && <span>{option.hint}</span>}
              </a>
            ) : (
              <span key={option.label} className="contact-button is-disabled" title="Contact email not set yet">
                <strong>{option.label}</strong>
                {option.hint && <span>{option.hint}</span>}
              </span>
            )
          )}
        </div>

        {emailIsSet ? (
          <p className="contact-note">
            Or write to us directly: <a href={`mailto:${OPERATOR.email}`}>{OPERATOR.email}</a>
          </p>
        ) : (
          <p className="contact-note">Contact email coming soon.</p>
        )}

        <h2>Frequently asked questions</h2>
        <div className="contact-faq">
          {FAQS.map(({ q, a }) => (
            <details key={q}>
              <summary>{q}</summary>
              <p>{a}</p>
            </details>
          ))}
        </div>

        <p className="contact-footnote">
          See also our <Link to="/terms">Terms of Service</Link> and <Link to="/privacy">Privacy Policy</Link>.
        </p>
      </div>
    </div>
  );
}
